import item from './store/item';
import store from '@/core/store';

export const connect = (opts = {}) => {
  store.registerModule('items$item', item);
};
